import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { CurrentUserService } from '@core/services';
import { AppRoutesEnum, UserRoleEnum } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class UserGuard implements CanActivate {
    constructor(private router: Router, private currentUserService: CurrentUserService) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {

        const currentUser = await this.currentUserService.initializeCurrentUser();

        if (currentUser) {
            return this.checkAccess(this.currentUserService.getCurrentUserRoles(), route.data['roles'] || []);
        }
        this.currentUserService.triggerUserDetailsError(true);
        return false;
    }

    checkAccess(userRoles: UserRoleEnum[], accessRoles: UserRoleEnum[]): boolean {
        if (accessRoles.length == 0) {
            // No role check if no roles are passed into the route
            return true;
        }
        if (accessRoles.some(accessRole => userRoles.includes(accessRole))) {
            return true;
        }
        this.router.navigate([AppRoutesEnum.BASE]);
        return false;
    }
}
